import { Link } from "react-router-dom";
import type { Actor } from "@/mocks/actors";
import ActorCard from "@/components/base/ActorCard";

interface HotActorsProps {
  actors: Actor[];
}

export default function HotActors({ actors }: HotActorsProps) {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
              热门演员推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              精选当前关注度较高的演员，点击卡片进入演员详情页。
            </p>
          </div>
          <Link
            to="/category/actor"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700"
          >
            查看全部演员
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {actors.map((a) => (
            <ActorCard key={a.id} actor={a} />
          ))}
        </div>
      </div>
    </section>
  );
}